import { gql } from "@apollo/client";


export const GET_DRIVER_SCHEDULER = gql`
  query getDriverUserScheduler(
    $view: String!
    $currentDate: String!
  ) {
    getDriverUserScheduler(
      view: $view
      currentDate: $currentDate
    ) {
      fromDate
      toDate
      drivers {
        user {
          id
          firstName
          lastName
          driverProfile {
            id
          }
        }
        dailySchedule {
          date
          jobs {
            id
            status
            jobDate
            description
          }
          events {
            id
            title
            startDate
            endDate
            eventType
            repeats
            notes
            color
          }
        }
      }
    }
  }
`;
